import { Link } from "react-router-dom";
import { reviews } from "@/mocks/reviews";
import SectionHeading from "@/components/feature/SectionHeading";

function ReviewsPreview() {
  const list = reviews.slice(0, 3);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            eyebrow="读者口碑"
            title="读者们怎么说"
            desc="来自不同追更阵营的真实评价与讨论，一起看看这部漫画在读者心中的模样。"
          />
          <Link
            to="/reviews"
            className="mb-8 inline-flex items-center gap-1 rounded-md px-3 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100 whitespace-nowrap"
          >
            查看全部评价 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {list.map((r) => (
            <article
              key={r.id}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-6"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-full ${r.avatar} font-heading text-base font-bold`}
                  >
                    {r.author.slice(0, 1)}
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950">{r.author}</h3>
                    <p className="text-xs text-foreground-500">{r.tag}</p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1 rounded-md bg-secondary-100 px-2.5 py-1 text-sm font-bold text-secondary-800">
                  {r.score}.0
                </span>
              </div>
              <p className="mt-4 font-heading text-base font-bold text-foreground-950">
                {r.title}
              </p>
              <p className="mt-2 flex-1 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                {r.content}
              </p>
              <div className="mt-5 flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i> {r.likes}
                </span>
                <span>{r.date}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ReviewsPreview;